'use client';

import { Tab } from '@common/components';
import { usePathname } from 'next/navigation';
import type { PropsWithChildren } from 'react';

import { PageNavigation } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

import { DesktopTitle } from '../../../_components/DesktopTitle';

const MyJejuRecommendLayout = ({ children }: PropsWithChildren) => {
  const pathname = usePathname() ?? '';
  const router = useCustomRouter();

  return (
    <article className="flex h-full flex-col">
      <PageNavigation isNotUsedHomeButton />
      <DesktopTitle className="mb-20">탐나는 제주패스</DesktopTitle>
      <Tab
        value={pathname}
        onChange={(newPathname) => router.replace(newPathname)}
      >
        <Tab.Item value={DONATION_ROUTES.MY_JEJU_RECOMMEND_INFO.pathname}>
          탐나는 제주패스란?
        </Tab.Item>
        <Tab.Item value={DONATION_ROUTES.MY_JEJU_RECOMMEND_MAP.pathname}>
          제주 혜택 지도
        </Tab.Item>
      </Tab>
      {children}
    </article>
  );
};

export default MyJejuRecommendLayout;
